import { createSlice } from "@reduxjs/toolkit";

export const noticSlice = createSlice({
  name: "notic",
  initialState: { value: "" },
  reducers: {
    noticReducer: (state, action) => {
      state.value = action.payload;
    },
  },
});
export const { noticReducer } = noticSlice.actions;
export default noticSlice.reducer;
